export const CENTER_ID = "__center__";
export const MAX_CONNECTIONS = 5;

export const NETWORK_CONFIG = {
  // Dot
  DOT_RADIUS_MOBILE: 2.5,
  DOT_RADIUS_DESKTOP: 3,
  MIN_DOT_SPACING_MOBILE: 35,
  MIN_DOT_SPACING_DESKTOP: 50,

  // Zoom
  ZOOM_LEVEL_MOBILE: 1.3,
  ZOOM_LEVEL_DESKTOP: 2,
  ZOOM_CENTER_Y_OFFSET_MOBILE: -0.14,
  ZOOM_CENTER_Y_OFFSET_DESKTOP: -0.1,

  // Connection
  CONNECTION_MIN_RADIUS_RATIO_MOBILE: 0.3,
  CONNECTION_MAX_RADIUS_RATIO_MOBILE: 0.45,
  CONNECTION_MIN_RADIUS_RATIO_DESKTOP: 0.18,
  CONNECTION_MAX_RADIUS_RATIO_DESKTOP: 0.35,
  CONNECTION_DELAY_MS_MOBILE: 300,
  CONNECTION_DELAY_MS_DESKTOP: 500,

  // Tooltip
  TOOLTIP_SCALE_MOBILE: 0.8,
  TOOLTIP_SCALE_DESKTOP: 0.65,
  TOOLTIP_WIDTH_MOBILE: 120,
  TOOLTIP_WIDTH_DESKTOP: 220,

  // Spacing
  SPACING_PADDING_MOBILE: 12,
  SPACING_PADDING_DESKTOP: 25,

  // Collision detection
  SPACING_RELAXATION_MULTIPLIER: 6,
  MINIMUM_TOOLTIP_GAP_PX: 8,
  MIN_TOOLTIP_OVERLAP_RATIO: 0.25,
  COLLISION_RELAXATION_PER_LEVEL: 4,
  MAX_RELAXATION_LEVELS: 3,
  MIN_ANGULAR_GAP_RADIANS_MOBILE: Math.PI / 4, // 45 degrees - stricter on mobile
  MIN_ANGULAR_GAP_RADIANS_DESKTOP: Math.PI / 6, // 30 degrees

  // Animation
  ANIMATION_BASE_DURATION_S: 0.2,
  ANIMATION_SPEED_DIVISOR: 400,
  ANIMATION_MAX_DURATION_S: 0.8,

  // Grid defaults
  DEFAULT_GRID_COLS: 11,
  DEFAULT_GRID_ROWS: 9,
  DEFAULT_DOT_SPACING: 60,

  SVG_ALIGNED_LINE_OFFSET: 0.01,
} as const;

export function getNetworkSettings(isMobile: boolean) {
  const pick = <T>(mobile: T, desktop: T): T => (isMobile ? mobile : desktop);

  return {
    dotRadius: pick(
      NETWORK_CONFIG.DOT_RADIUS_MOBILE,
      NETWORK_CONFIG.DOT_RADIUS_DESKTOP
    ),
    minDotSpacing: pick(
      NETWORK_CONFIG.MIN_DOT_SPACING_MOBILE,
      NETWORK_CONFIG.MIN_DOT_SPACING_DESKTOP
    ),
    zoomLevel: pick(
      NETWORK_CONFIG.ZOOM_LEVEL_MOBILE,
      NETWORK_CONFIG.ZOOM_LEVEL_DESKTOP
    ),
    zoomCenterYOffset: pick(
      NETWORK_CONFIG.ZOOM_CENTER_Y_OFFSET_MOBILE,
      NETWORK_CONFIG.ZOOM_CENTER_Y_OFFSET_DESKTOP
    ),
    connectionRadiusRatios: {
      min: pick(
        NETWORK_CONFIG.CONNECTION_MIN_RADIUS_RATIO_MOBILE,
        NETWORK_CONFIG.CONNECTION_MIN_RADIUS_RATIO_DESKTOP
      ),
      max: pick(
        NETWORK_CONFIG.CONNECTION_MAX_RADIUS_RATIO_MOBILE,
        NETWORK_CONFIG.CONNECTION_MAX_RADIUS_RATIO_DESKTOP
      ),
    },
    connectionDelay: pick(
      NETWORK_CONFIG.CONNECTION_DELAY_MS_MOBILE,
      NETWORK_CONFIG.CONNECTION_DELAY_MS_DESKTOP
    ),
    tooltipScale: pick(
      NETWORK_CONFIG.TOOLTIP_SCALE_MOBILE,
      NETWORK_CONFIG.TOOLTIP_SCALE_DESKTOP
    ),
    tooltipWidth: pick(
      NETWORK_CONFIG.TOOLTIP_WIDTH_MOBILE,
      NETWORK_CONFIG.TOOLTIP_WIDTH_DESKTOP
    ),
    spacingPadding: pick(
      NETWORK_CONFIG.SPACING_PADDING_MOBILE,
      NETWORK_CONFIG.SPACING_PADDING_DESKTOP
    ),
    minAngularGap: pick(
      NETWORK_CONFIG.MIN_ANGULAR_GAP_RADIANS_MOBILE,
      NETWORK_CONFIG.MIN_ANGULAR_GAP_RADIANS_DESKTOP
    ),
  };
}
